import { render, staticRenderFns } from "./UCIrvineChem1LC_FS3_Safety1.vue?vue&type=template&id=2bcf178e&scoped=true&"
import script from "./UCIrvineChem1LC_FS3_Safety1.vue?vue&type=script&lang=ts&"
export * from "./UCIrvineChem1LC_FS3_Safety1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcf178e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VForm,VRadio,VRadioGroup,VRow,VTextarea})
